import 'selectric'
import GLightbox from 'glightbox';
// import 'owl.carousel'

(function($) {
  'use strict';

  // ===============================================================================
  // VAR
  // ===============================================================================
  // var $btnMenu = $('.js-open-menu');
  // var $btnMenuClose = $('.js-close-menu');
  // var $menu = $('.js-menu');
  var header_fixe = $('.js-header-fixe');
  var wrapper = $('.page-main');

  // ===============================================================================
  // INIT
  // ===============================================================================

  /* GLightbox
  *******************************************************************************/
	function runGlightbox() {
    const lightbox = GLightbox({
      autoplayVideos: true,
      loop: true
    });
  }
  runGlightbox();



  // ===============================================================================
  // GLOBAL
  // ===============================================================================

  /* Responsive menu / lance animations
  *******************************************************************************/
	$(window).on('load resize', function (event, newSize, oldSize) {
		// Menu
		if ($('.js-menu').length && window.matchMedia('(min-width: 1024px)').matches) {
			$('.js-menu').removeClass('is-open');
			$('.sub-menu').removeClass('is-open');
			$('body').removeClass('menu-open');
		}

		// Lance les animations
		runAnimation();

		if (window.matchMedia('(min-width: 1024px)').matches) {
			$('.js-filter').slideDown();
		}
	});

	$('.js-menu').find('.menu-item-has-children > .menu-link').on('click', function (e) {
		if (window.matchMedia('(max-width: 1024px)').matches) {
			e.preventDefault();

			if ($(this).next('.sub-menu').hasClass('is-open')) {
				$(this).next('.sub-menu').removeClass('is-open');
			} else {
				$(this).next('.sub-menu').addClass('is-open');
			}
		}
	});

	$('.js-open-menu').on('click', function (e) {
		console.log('Hello you');
		e.preventDefault();

		if ($('.js-menu').hasClass('is-open')) {
			$('.js-menu').removeClass('is-open');
			$('body').removeClass('menu-open');
			$('body').addClass('menu-close');
		} else {
			$('.js-menu').addClass('is-open');
			$('body').addClass('menu-open');
			$('body').removeClass('menu-close');
		}
	});

	$(document).on('click touchstart', function (event) {
		if (!$(event.target).closest('.js-menu').length && !$(event.target).closest('.js-open-menu').length) {
			$('body').removeClass('menu-open');
			$('.js-menu').removeClass('is-open');
		}
	});

  // Menu fixe au scroll
  // *******************************************************************************

	var header_fixe = $('.js-header-fixe');
	var wrapper = $('.page-main');

  $(document).on('resize scroll', function () {
		if (window.matchMedia('(min-width: 1024px)').matches) {
			var position_scroll = $(window).scrollTop();

			var height_header = header_fixe.height();
			if (position_scroll >= (height_header)) {
				header_fixe.addClass('is-sticky', 300);
			} else {
				header_fixe.removeClass('is-sticky', 300);
			}
		}
	});

  /* Animation ancre
  *******************************************************************************/
  $("a[href*='#']:not([href='#']):not(.tabs-link)").click(function() {
    if ( location.hostname == this.hostname && this.pathname.replace(/^\//,"") == location.pathname.replace(/^\//,"") ) {
      var anchor = $(this.hash);
      anchor = anchor.length ? anchor : $("[name=" + this.hash.slice(1) +"]");
      if ( anchor.length ) {
          $("html, body").animate( { scrollTop: anchor.offset().top }, 600);
      }
    }
  });

  /* Show/hide "go top" button
  *******************************************************************************/
  $(document).on('scroll DOMNodeInserted', function() {
    var scroll = $(window).scrollTop();

    if (scroll >= ($(window).height() - 300)) { // Show
        $('.js-scrollTop').addClass('is-active');
    }
    if (scroll <= ($(window).height() - 300)) { // Hide
        $('.js-scrollTop').removeClass('is-active');
    }
  });

  // ===============================================================================
  // CONTENU
  // ===============================================================================

	/* Gestion du changement d'adresse - Coordonnées
	*******************************************************************************/
	$('.js-coordinate-address-change').on('change', function () {
		$('.js-coordinate-address').addClass('hide')
		$('.js-coordinate-address[data-id="' + $(this).val() + '"]').removeClass('hide')
	})


	// ===============================================================================
	// TABS
	// ===============================================================================
	$('.wp-block-mu-tabs-nav-item').on('click', function () {
		const parentTabs = $(this).parents('.wp-block-mu-tabs')
		const currentTab = $(this).attr('data-tab')

		// on vire la classe is-active sur tous
		$('.wp-block-mu-tabs-nav-item').removeClass('is-active')
		parentTabs.find('.wp-block-mu-tab').removeClass('is-active')

		// on l'ajoute sur la nouvelle
		$(this).addClass('is-active')
		parentTabs.find('.wp-block-mu-tab[data-tab="' + currentTab + '"]').addClass('is-active')
	})

	// ===============================================================================
	// ACCORDEON
	// ===============================================================================
	$('.wp-block-mu-accordion-title').on('click', function () {
		$(this).toggleClass('is-open');
		$(this).next('.wp-block-mu-accordion-content').slideToggle();
	})

  // ===============================================================================
  // ANIMATIONS
  // ===============================================================================
  // ELEMENT VISIBLE AU SCROLL
  function elementInView(elem) {
    return ($(window).height() + $(window).scrollTop() - 300) > $(elem).offset().top;
  };

  function humanizeNumber(n) {
    var n = n.toString()
    while (true) {
      var n2 = n.replace(/(\d)(\d{3})($|,|\.)/g, '$1 $2$3')
      if (n == n2) break
      n = n2
    }
    return n
  }

  function runAnimation(event) {

    var win = $(window);
    var allMods = $('.js-animate-display');

    allMods.each(function (i, el) {
      var el = $(el);

      if (elementInView(el)) {
        el.addClass('already-visible');
      }
    });

    win.scroll(function (event) {
      allMods.each(function (i, el) {
        var el = $(el);
        if (elementInView(el)) {
          el.addClass('visible');
        }
      });
    });
  }

  // ===============================================================================
  // OWL CAROUSEL
  // ===============================================================================
  // if($('.owl-block-customer-promote').length){
  //   $('.owl-block-customer-promote').owlCarousel({
  //     loop: true,
  //     nav: true,
  //     dots: false,
  //     margin: 60,
  //     mouseDrag: false,
  //     autoplay: true,
  //     autoplayHoverPause: true,
  //     responsive : {
  //       0 : {
  //         items: 2
  //       },
  //       640 : {
  //         items: 3
  //       },
  //       1024 : {
  //         items: 6
  //       }
  //     }
  //   });
  // }

  // ===============================================================================
  // FORMULAIRE
  // ===============================================================================

  // Ajout du plugin pour looker les selects
  // *******************************************************************************
  function runSelect() {
    if($('select').length){
      $('select').selectric({
        forceRenderBelow: true
      });
    }
  }
  runSelect();

  // ajoute une classe si le champ est rempli pour changer la position du label
  // *******************************************************************************
  function addClassFillField(){
    // au chargement
    $('input, textarea').each(function(){
      if($(this).val().length > 0){
        $(this).addClass('is-filled');
      } else {
        $(this).removeClass('is-filled');
      }
    });

    // au changement
    $('input, textarea').on('change', function(){
      if($(this).val().length > 0){
        $(this).addClass('is-filled');
      } else {
        $(this).removeClass('is-filled');
      }
    });

    // dans le cas de selectric
    $('select').each(function(){
      if( $(this).val() != '' ) {
        $(this).parents('.selectric-wrapper').addClass('is-filled');
      }

      $(this).on('selectric-change', function(event, element, selectric) {
        if( $(this).val() != '' ) {
          $(this).parents('.selectric-wrapper').addClass('is-filled');
        }
      });
    });
  }
  addClassFillField();

  // Permet de mettre en place le style check / pas check sur les radio & checkbox
  // *******************************************************************************
  $(document).on('click', '.frm_checkbox label, .frm_radio label', function(){
    $('input[type="checkbox"]:not(:checked), input[type="radio"]:not(:checked)').parent('label').removeClass('checked');
    $('input[type="checkbox"]:checked, input[type="radio"]:checked').parent().addClass('checked');
  });

  // ===============================================================================
  // AJAX
  // ===============================================================================
  $( document ).ajaxComplete(function() {
    // Réinitialiser les librairies
    runSelect();
		runGlightbox();

    // Lance animations
		if(window.matchMedia('(min-width: 1024px)').matches){
      runAnimation();
    }

    // Ajoute les classes sur les champs remplis
    addClassFillField();
  });

  // ===============================================================================
  // MAP COMMERCIAL
  // ===============================================================================
  $('.js-map-form-open').on('click', function(e){
    e.preventDefault();

    var $this = $(this);

    $this.parents('.js-map-form-svg').append('<span class="throbber"></span>'); // on lance le loader

    // var $url = $this.attr('data-url'); // on récupère l'url du add node prospect
    var department = $this.attr('data-dept'); // on récupère le dept

    // on enlève la classe active sur celui déjà ouvert
    $('.js-map-form-open').each(function(){
        $(this).removeAttr('data-class');
    });

    // on active le département
    $this.attr('data-class', 'is-active');

    $('.js-map-form-ajax').empty();

    var valuesFilter = {
      'action': 'mapcontact', // le nom de l'action dans le function.php
      'department': department, // le template à afficher
    };

    jQuery.post(
      ajaxurl,
      valuesFilter,
      function(response){
        $('.js-map-form-ajax').html(response); // on ajoute le contenu retourné par l'action dans le function.php

        // on rempli le champ
        $('#field_commercial').val(department);

        // on affiche le formulaire
        $('.js-map-form').removeClass('hide');

        $this.parents('.js-map-form-svg').find('.throbber').remove(); // on remove le loader

        $('html, body').animate({scrollTop:$('.js-map-form-ajax').position().top}, 'slow'); // on revient en haut de page
      }
    );
  });

  // ===============================================================================
  // INTERNET EXPLORER
  // ===============================================================================
  if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1)){
		// @todo
  }

  // ===============================================================================
  // FUNCTIONS
  // ===============================================================================

})(jQuery);
